import { createContext } from 'react';

export const PrepareDisclosuresWizardContext = createContext(null);
